import { useFetchGiftCards } from "features/giftcards/hooks/useFetchGiftCards";
import CategoryChip from "../categoryChip/CategoryChip";
import { GiftCardCategorySelectorRoot } from "./GiftCardCategorySelector.styles";
import { Col, Divider } from "@commonlibs";

function GiftCardCategorySelector({ categories }: { categories: string[] }) {
    const { categorySelected, handleSelectCategory } = useFetchGiftCards();

    return (
        <>
            {categories.length > 1 && (
                <Col>
                    <GiftCardCategorySelectorRoot>
                        {categories.map((category) => (
                            <CategoryChip
                                key={category}
                                category={category}
                                selected={category === categorySelected}
                                handleClick={handleSelectCategory}
                            />
                        ))}
                    </GiftCardCategorySelectorRoot>
                    <Divider />
                </Col>
            )}
        </>
    );
}

export default GiftCardCategorySelector;
